import { EditOtherContentInterface } from '@/data/payload/contracts/OtherContentRequest'

export class EditOtherContentApiRequest implements EditOtherContentInterface {
  private name: string
  private content: any
  private fileUpload: any

  constructor(name: string, content: string, fileUpload: any) {
    this.name = name
    this.content = content
    this.fileUpload = fileUpload
  }

  public toJSON() {
    const data = {
      name: this.name,
      content: this.content,
    }

    return JSON.stringify({
      data,
    })
  }

  public toFormData() {
    if (this.name === 'tutorial') {
      const data = new FormData()
      data.append('name', this.name)
      data.append('fileUpload', this.fileUpload)
      return data
    } else {
      const data = new FormData()
      data.append('name', this.name)
      data.append('content', this.content)
      return data
    }
  }
}
